import { useState } from "react";

export interface IFieldState {
  value: string;
  message: string;
  required: boolean;
}

export type IFormState = Record<string, IFieldState>;

/** Minimal form-state hook: value + inline error per field, error clears on change. */
export const useForm = (initial: IFormState) => {
  const [form, setForm] = useState<IFormState>(initial);

  const onChange = (name: string, value: string) => {
    setForm((prev) => ({
      ...prev,
      [name]: { ...prev[name], value, message: "" },
    }));
  };

  return { form, setForm, onChange };
};
